import { createContext } from 'react';

const ProductionContext = createContext();

export default ProductionContext;
